export enum Features {
    AfasArticles = 'afasArticles',
    AfasDebtors = 'afasDebtors',
    AfasInvoiceDetailSave = 'afasInvoiceDetailSave',
    AfasInvoices = 'afasInvoices',
    AuthAddFeatureToFunctionalitySave = 'authAddFeatureToFunctionalitySave',
    AuthAddFunctionalityToRoleSave = 'authAddFunctionalityToRoleSave',
    AuthFeatures = 'authFeatures',
    AuthFunctionalities = 'authFunctionalities',
    AuthRemoveFeatureFromFunctionalitySave = 'authRemoveFeatureFromFunctionalitySave',
    AuthRemoveFunctionalityFromRoleSave = 'authRemoveFunctionalityFromRoleSave',
    AuthRoles = 'authRoles',
    AzureOpentasks = 'azureOpentasks',
    AzurePullrequests = 'azurePullrequests',
    AzurePullrequestsWeek = 'azurePullrequestsWeek',
    AzurePullrequestsWorkitems = 'azurePullrequestsWorkitems',
    AzureQuerylinks = 'azureQuerylinks',
    AzureTaskSorting = 'azureTaskSorting',
    AzureTasksSortSave = 'azureTasksSortSave',
    Checkpoints = 'checkpoints',
    Checkpoints_checkpointId_Results = 'checkpoints_checkpointId_Results',
    CheckpointsComments_checkpoint_id_ = 'checkpointsComments_checkpoint_id_',
    CheckpointsCommentsDetailDelete = 'checkpointsCommentsDetailDelete',
    CheckpointsCommentsSave = 'checkpointsCommentsSave',
    CheckpointsCommentsShowDetail = 'checkpointsCommentsShowDetail',
    CheckpointsDetail = 'checkpointsDetail',
    CheckpointsDetailDelete = 'checkpointsDetailDelete',
    CheckpointsIndex = 'checkpointsIndex',
    CheckpointsQueueImmediatelySave = 'checkpointsQueueImmediatelySave',
    CheckpointsResultsContent_hash_ = 'checkpointsResultsContent_hash_',
    CheckpointsResultsDetail = 'checkpointsResultsDetail',
    CheckpointsSave = 'checkpointsSave',
    Companies = 'companies',
    CompaniesAzurefeatures = 'companiesAzurefeatures',
    CompaniesAzureitems = 'companiesAzureitems',
    CompaniesAzureteams = 'companiesAzureteams',
    CompaniesColors = 'companiesColors',
    CompaniesDetail = 'companiesDetail',
    CompaniesDetailDelete = 'companiesDetailDelete',
    CompaniesHavingregistrations = 'companiesHavingregistrations',
    CompaniesSave = 'companiesSave',
    FinancialHourlycompanies = 'financialHourlycompanies',
    FinancialHourlyemployees = 'financialHourlyemployees',
    Leave = 'leave',
    LeaveApprove = 'leaveApprove',
    LeaveDetail = 'leaveDetail',
    LeaveDetailDelete = 'leaveDetailDelete',
    LeaveRealisationsDetail = 'leaveRealisationsDetail',
    LeaveSave = 'leaveSave',
    LeaveType = 'leaveType',
    LeaveUnapproved = 'leaveUnapproved',
    Platforms = 'platforms',
    PlatformsDetail = 'platformsDetail',
    PlatformsDetailDelete = 'platformsDetailDelete',
    PlatformsSave = 'platformsSave',
    ProjectAll = 'projectAll',
    ProjectAzure = 'projectAzure',
    ProjectFindhidden = 'projectFindhidden',
    ProjectTogglevisibleSave = 'projectTogglevisibleSave',
    ProjectVisible = 'projectVisible',
    RegistrationReportCompanies = 'registrationReportCompanies',
    RegistrationReportUsers = 'registrationReportUsers',
    Registrations = 'registrations',
    RegistrationsAll = 'registrationsAll',
    RegistrationsApproveDetailSave = 'registrationsApproveDetailSave',
    RegistrationsChangeProjectSave = 'registrationsChangeProjectSave',
    RegistrationsDisapproveDetailSave = 'registrationsDisapproveDetailSave',
    RegistrationsPdfUnderlaySave = 'registrationsPdfUnderlaySave',
    RegistrationsProfileTotals = 'registrationsProfileTotals',
    RegistrationsProfileTotalsOverview = 'registrationsProfileTotalsOverview',
    RegistrationsReportPdf = 'registrationsReportPdf',
    RegistrationsSaveSave = 'registrationsSaveSave',
    RegistrationsTotals = 'registrationsTotals',
    RegistrationsWeeklyhours = 'registrationsWeeklyhours',
    Servers = 'servers',
    Subscriptions = 'subscriptions',
    SubscriptionsDetail = 'subscriptionsDetail',
    SubscriptionsDetailDelete = 'subscriptionsDetailDelete',
    SubscriptionsSave = 'subscriptionsSave',
    Users = 'users',
    Users_userId_Delete = 'users_userId_Delete',
    UsersAssignmentReport = 'usersAssignmentReport',
    UsersDetail = 'usersDetail',
    UsersSave = 'usersSave',
}
